import { useState, useEffect, useCallback } from 'react';

interface UseDebounceSearchOptions {
  minLength?: number;
  delay?: number;
}

export const useDebounceSearch = (
  callback: (query: string) => void,
  options: UseDebounceSearchOptions = {}
) => {
  const { minLength = 4, delay = 300 } = options;
  const [searchQuery, setSearchQuery] = useState('');

  const debouncedSearch = useCallback(
    (query: string) => {
      setSearchQuery(query);
    },
    []
  );

  useEffect(() => {
    if (searchQuery.length >= minLength) {
      const timer = setTimeout(() => {
        callback(searchQuery);
      }, delay);

      return () => clearTimeout(timer);
    } else if (searchQuery.length === 0) {
      // Clear results when search is empty
      callback('');
    }
  }, [searchQuery, callback, minLength, delay]);

  return {
    searchQuery,
    debouncedSearch,
    isSearching: searchQuery.length > 0 && searchQuery.length < minLength
  };
};